<template>
<div class="mt-2">
  <div class="table-responsive">
    <table>
      <thead>
        <tr>
          <th>
            <button @click="agregarFila" class="btn-success"><i class="fa fa-plus"></i></button>
          </th>
          <th># Secuencia</th>
          <th>Descripción</th>
          <th>Tipo</th>
          <th># Actual</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr :class="{'tr--canceled' : puntoEmision.estado === 'I', 'tr--authorized' : puntoEmision.estado === 'A'}" v-for="(puntoEmision, index) in modelValue" :key="index">
          <td>
            <button @click="editarFila(index)" class="btn-info btn--text" type="button"><i class="fa fa-edit"></i></button>
          </td>
          <td>
            <input-field readonly :id="puntoEmision + index" v-model="puntoEmision.numero_secuencia" placeholder="###">
              <span v-if="errores.hasOwnProperty('puntosEmision.' + index + '.numero_secuencia')" class="helper-text text-danger"
                slot="helper">
                {{ errores['puntosEmision.' + index + '.numero_secuencia'][0] }}
              </span>
              <span v-else-if="errores.hasOwnProperty('puntosEmision.' + index + '.numero_inicial')" class="helper-text text-danger"
                slot="helper">
                * {{ errores['puntosEmision.' + index + '.numero_inicial'][0] }}
              </span>
              <span v-else-if="errores.hasOwnProperty('puntosEmision.' + index + '.numero_final')" class="helper-text text-danger"
                slot="helper">
                * {{ errores['puntosEmision.' + index + '.numero_final'][0] }}
              </span>
              <span v-else-if="errores.hasOwnProperty('puntosEmision.' + index + '.numero_autorizacion')" class="helper-text text-danger"
                slot="helper">
                * {{ errores['puntosEmision.' + index + '.numero_autorizacion'][0] }}
              </span>
              <span v-else-if="errores.hasOwnProperty('puntosEmision.' + index + '.fecha_autorizacion')" class="helper-text text-danger"
                slot="helper">
                * {{ errores['puntosEmision.' + index + '.fecha_autorizacion'][0] }}
              </span>
            </input-field>
          </td>
          <td>
            <input-field :id="'descripcion' + index" v-model="puntoEmision.descripcion" placeholder="Nombre del punto"
              readonly>
              <span v-if="errores.hasOwnProperty('puntosEmision.' + index + '.descripcion')" class="helper-text text-danger"
                slot="helper">
                {{ errores['puntosEmision.' + index + '.descripcion'][0] }}
              </span>
            </input-field>
          </td>
          <td>{{ puntoEmision.tipo }}</td>
          <td>
            <input-field :id="'descripcion' + index" v-model="puntoEmision.numero_actual" placeholder="Nombre del punto"
              readonly>
              <span v-if="errores.hasOwnProperty('puntosEmision.' + index + '.numero_actual')" class="helper-text text-danger"
                slot="helper">
                {{ errores['puntosEmision.' + index + '.numero_actual'][0] }}
              </span>
            </input-field>
          </td>
          <td>
            <button v-show="puntoEmision.estado === 'A'" @click="eliminarFila(index)" class="btn-danger btn--text" type="button"><i class="fa fa-trash-o"></i></button>
            <button v-show="puntoEmision.estado === 'I'" @click="eliminarFila(index)" class="btn-success btn--text" type="button"><i class="fa fa-power-off"></i></button>
          </td>
        </tr>
        <tr v-show="modelValue.length === 0">
          <td colspan="5">
            <strong>Agregue una fila.</strong>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <modal :clickToClose="false" scrollable name="puntoEmision" height="auto" width="60%">
    <punto-emision @input="inputPuntoEmision" @cerrar="cerrarPuntoEmision" v-model="selectedPuntoEmision"></punto-emision>
  </modal>
</div>
</template>

<script>
export default {
    props : {
        value : {
            type : Array,
            default : function () {
                return [];
            },
            required : false
        },
        errores : {
            type : Object,
            default : function () {
                return {};
            },
            required : true
        }
    },
    data : function () {
        return {
            modelValue : this.value,
            selectedPuntoEmision : {
                id : '',
                numero_secuencia : '',
                descripcion : '',
                tipo : 'E',
                numero_inicial : '',
                numero_actual : '',
                numero_final : '',
                numero_autorizacion : '',
                id_tipo_comprobante : '',
                fecha_autorizacion : moment(new Date()).format('YYYY-MM-DD'),
                estado : 'A',
                fecha_caducidad : moment(new Date()).format('YYYY-MM-DD'),
                medida_superior : 0,
                medida_inferior : 0,
                punto_venta : false,
                pre_impresion : false,
                usuarios : [],
                app: false
            },
            nuevoPuntoEmision : false,
            selectedIndex : -1,
            url : url
        };
    },
    methods : {
        agregarFila : function () {
            let newIndex = this.modelValue.push({
                id : '',
                numero_secuencia : '',
                descripcion : '',
                tipo : 'E',
                numero_inicial : '',
                numero_actual : '',
                numero_final : '',
                numero_autorizacion : '',
                fecha_autorizacion : moment(new Date()).format('YYYY-MM-DD'),
                id_tipo_comprobante : '',
                estado : 'A',
                fecha_caducidad : moment(new Date()).format('YYYY-MM-DD'),
                medida_superior : 0,
                medida_inferior : 0,
                punto_venta : false,
                pre_impresion : false,
                usuarios : [],
                es_autorizable: true,
                precargar_numero: true,
                nombre_campo: '',
                valor_campo: '',
                app: false,
                autorizar_automatico: false,
                usuario_id: ''
            }) - 1;
            this.selectedIndex = newIndex;
            this.selectedPuntoEmision = JSON.parse(JSON.stringify(this.modelValue[newIndex]));
            this.nuevoPuntoEmision = true;
            this.$modal.show('puntoEmision');
        },
        eliminarFila : function (index) {
            let that = this;
            swal({
                    title: '¿Está seguro de ' + (that.modelValue[index].id === ''?'eliminar':(that.modelValue[index].estado === 'A')?'eliminar':'re-activar') + ' este punto de emisión?',
                    text: "Pregunta",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText : 'Sí',
                    cancelButtonText : 'Cancelar'
                    }).then((result) => {
                        if (result.value)
                        {
                            axios.post(that.url + '/puntos-emision/' + that.modelValue[index].id, {
                                _method : 'DELETE'
                            }).then(function (response) {
                                if (that.modelValue[index].id === '')
                                    that.modelValue.splice(index, 1);
                                else 
                                {
                                    if (that.modelValue[index].estado === 'A')
                                        that.modelValue[index].estado = 'I';
                                    else 
                                        that.modelValue[index].estado = 'A';
                                }
                            }).catch(function (error) {
                                if (error !== undefined && error !== null)
                                    swal('No se pudo realizar la acción solicitada.', 'Mensaje', 'error');
                            });
                        }
                });
            
        },
        editarFila : function (index) {
            this.selectedIndex = index;
            this.selectedPuntoEmision = JSON.parse(JSON.stringify(this.modelValue[index]));
            this.$modal.show('puntoEmision');
        },
        cerrarPuntoEmision : function () {
            let that = this;
            swal({
                    title: '¿Está seguro de cerrar el formulario?',
                    text: "Los datos ingresados se perderán.",
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonText : 'Cerrar',
                    cancelButtonText : 'Cancelar'
                    }).then((result) => {
                        if (result.value)
                        {
                            if (that.nuevoPuntoEmision)
                                that.modelValue.splice(that.modelValue.indexOf(that.selectedPuntoEmision), 1);
                            that.$modal.hide('puntoEmision');
                            that.selectedIndex = -1;
                        }
                });
        },
        inputPuntoEmision : function (value) {
            this.nuevoPuntoEmision = false;
            this.modelValue.splice(this.selectedIndex, 1, value);
            this.$modal.hide('puntoEmision');
            this.selectedIndex = -1;
        }
    },
    watch : {
        value : function (value) {
            this.modelValue = value;
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/localidades/TablaPuntoEmision.vue